import React, { useState } from "react";
import { Modal, ModalBody, ModalTitle, Nav, Navbar } from "react-bootstrap";
import ModalHeader from "react-bootstrap/esm/ModalHeader";
import NavbarCollapse from "react-bootstrap/esm/NavbarCollapse";
import { useAuth } from "../contexts/AuthContext";

/**Footer component */
const Footer = ({ children }: { children?: React.ReactNode }) => {
  const [modalContactOpen, setModalContactOpen] = useState(false);
  //const preservedSpace = useRef<HTMLDivElement>(null);
  const authState = useAuth();
  const { userInfo, isAuthenticated } = authState.state || {};

  /**Preserved footer space
  const preservedFooter=()=>{
    return (
      <footer>
        <div ref={this.preservedSpace}></div>
      </footer>
    );
  }
  */

  return (
    <div className="mt-5">
      <Navbar role="contentinfo" className="border-top bg-light" fixed="bottom">
        <NavbarCollapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Item>
              <Nav.Link
                className="footer-link footer-nav-link"
                href="/impressum"
              >
                Impressum
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className="footer-link footer-nav-link"
                href="/privacypolicy"
              >
                Datenschutz
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className="footer-link footer-nav-link"
                onClick={
                  isAuthenticated
                    ? undefined
                    : () => {
                        setModalContactOpen(true);
                      }
                }
                href={isAuthenticated ? "/contact" : undefined}
              >
                Kontakt
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </NavbarCollapse>
      </Navbar>

      <Modal
        show={modalContactOpen}
        onHide={() => {
          setModalContactOpen(false);
        }}
      >
        <ModalHeader closeButton>
          <ModalTitle>Kontakt</ModalTitle>
        </ModalHeader>
        <ModalBody>
          {userInfo?.userType === "patient" ? (
            <p>Bitte wenden Sie sich an Ihr zuständiges Klinikpersonal.</p>
          ) : userInfo?.userType === "clinician" ? (
            <p>Bitte wenden Sie sich an Ihre*n Klinikadministrator*in.</p>
          ) : (
            <p>
              Bitte wenden Sie sich an{" "}
              <a href="mailto:rehacat.technik@uni-ulm.de">
                rehacat.technik@uni-ulm.de
              </a>
              .{" "}
            </p>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Footer;
